import React from 'react';
import { buildEventMessageRowMeta } from './eventMessageRowMetaUtils';
import AdminSenderName from './AdminSenderBadge';

export function buildEventMessageRowViewModel({
  message,
  isAnnouncement = false,
  isMyMessage = false,
  hideSenderMeta = false,
  shouldSubtractSelfRead = true,
  getMainPartLabel,
  getAnnouncementSenderName,
  senderNameFallback = '',
  useFullWidthPartParentheses = false,
  bubbleClassByType,
  variant = 'plain',
  timeLabel = '',
  activeAnchorMessageId,
  sourceEventLabel = '',
  showSourceBadge = false,
  sourceBadgeClassName,
  renderAnnouncementAvatarLeft,
  renderAdminAvatarLeft,
  renderArtistAvatarLeft,
  onAvatarClick,
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
}) {
  const rowMeta = buildEventMessageRowMeta({
    message,
    isAnnouncement,
    isMyMessage,
    hideSenderMeta,
    shouldSubtractSelfRead,
    getMainPartLabel,
    getAnnouncementSenderName,
    senderNameFallback,
    announcementSide: 'admin',
    selfSide: 'artist',
    otherSide: 'admin',
    bubbleClassByType,
    useFullWidthPartParentheses,
  });

  const avatarNode =
    rowMeta.rowSide === 'admin'
      ? (
          isAnnouncement
            ? renderAnnouncementAvatarLeft?.(message)
            : (message?.isAdminMsg
              ? renderAdminAvatarLeft?.(message, onAvatarClick ? () => onAvatarClick(message) : undefined)
              : renderArtistAvatarLeft?.(message, onAvatarClick ? () => onAvatarClick(message) : undefined))
        )
      : null;

  const senderContent = rowMeta.isAdminSender
    ? <AdminSenderName name={rowMeta.senderText} />
    : rowMeta.senderText;

  const beforeLineContent = showSourceBadge && sourceEventLabel ? (
    <span className={sourceBadgeClassName}>{sourceEventLabel}</span>
  ) : null;

  return {
    variant,
    messageId: message?.id,
    isSelf: rowMeta.isSelfRow,
    senderContent,
    showSender: !isAnnouncement && !hideSenderMeta && !rowMeta.isSelfRow,
    readCount: rowMeta.displayReadCount,
    timeLabel,
    metaExtra: null,
    bubbleClassName: rowMeta.bubbleClassName,
    anchorActive: String(activeAnchorMessageId) === String(message?.id),
    anchorClassName: 'is-anchor-hit',
    avatarNode,
    beforeLineContent,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
    onTouchMove,
  };
}
